import DataTable from "core/ui/data-table";
import {withRouter, Link} from 'react-router-dom';
import FormatDateTime from "core/utils/FormatDateTime";
import { Button } from "reactstrap";

const table_columns = [
  { header: 'ID', key: 'id'},
  { header: 'Name', key: 'name'},
  { header: 'Code', key: 'code'},
  { header: 'Parent Company', key: 'parent_name'},
  { header: 'Date Created', key: 'created_date', render: (value) => <FormatDateTime date={value.created_date} />},
  { header: 'License Override', key: 'override_license_requirement', data_type: 'boolean', render: (value) => <span>{value.override_license_requirement ? "Yes" : "No"}</span>},
  { header: 'Demo Instance', key: 'demo_instance', data_type: 'boolean', render: (value) => <span>{value.demo_instance ? "Yes" : "No"}</span>},
  { header: 'Disable Banner', key: 'disable_banner', data_type: 'boolean', render: (value) => <span>{value.disable_banner ? "Yes" : "No"}</span>}
];

const Companies = (props) => {
  function onClickNew(ev) {
    ev.stopPropagation();
    props.history.push('/admin-company-form')
  }

  const table_actions = (company)=>
  <ul className="action-menu">
    <Link to={'/admin-company-form#company_id='+ company.id}> <i className="bi bi-pencil"></i>Edit</Link>
  </ul>;

  return (
      <div className="page admin-page">
        <div className="list-header sticky-page-header">
          <Link to={"/admin"}>
            <button className="new-button">
              <i className="bi bi-chevron-left"></i> Admin
            </button>
          </Link>
          <h1>Companies</h1>
          <i className="spacer" />
          <Button className='new-button' onClick={onClickNew}>New Company</Button>
        </div>
        <div className="companies-backdrop">&nbsp;</div>
        <DataTable query='companies/list'
                  cols={table_columns}
                  actions={table_actions}
                  empty='No Companies Found' />
      </div>
  );
};
export default withRouter(Companies);
